<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>经销商用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>经销商用户列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="请输入用户手机号" clearable v-model="queryInfo.query" @clear="getUserList()">
                        <el-button slot="append" icon="el-icon-search" @click="getUserList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="2" style="line-height: 40px;">
                    <el-checkbox v-model="queryInfo.lock_user" @change="getUserList">锁定用户</el-checkbox>
                </el-col>
                
                <el-col :span="4"><el-button type="primary" @click=" addDialogVisible = true" >添加用户</el-button></el-col>
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--用户列表区域-->
            <el-table :data="userlist"  :key="userlist.index" style="width: 100%" stripe size="middle" height="600">     
                <el-table-column  type="expand">
                    <template slot-scope="scope">
                        <div style="padding: 0px 48px;">
                            <el-table :data="scope.row.children"  :key="scope.row.children.id" style="width: 100%" size="middle" :show-header=false >
                                <el-table-column label="ID" type="index"  width="100" ></el-table-column>
                                <el-table-column label="用户名" prop="username" width="150"></el-table-column>
                                <el-table-column label="昵称" prop="nick_name" width="150"></el-table-column>
                                <el-table-column label="积分" prop="integral" width="150"></el-table-column>
                                <el-table-column label="姓名" prop="name" width="150"></el-table-column>
                                <el-table-column label="身份证" prop="sfz" width="200"></el-table-column>
                                <el-table-column label="经销商" prop="is_dealer" width="100">
                                    <template  slot-scope="scope1">
                                        <span style="color:#33cc00" v-if="scope1.row.is_dealer">是</span>
                                        <span style="color:#ff0000" v-else>否</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="锁定" prop="is_activated" width="200">
                                    <template  slot-scope="scope1">
                                        <i class="el-icon-lock" v-if="scope1.row.is_deleted == 1" style="font-size: 14px;"></i>
                                        <span style="color:#33cc00" v-else>正常</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作">
                                    <!--作用域插槽-->
                                    <template slot-scope="scope1"> 
                                            <!-- <el-button type="primary" icon="el-icon-edit" size="mini" @click="EditUser(scope1.row.username)" v-if="admin_token == 'admin' || admin_token == 'user'"></el-button> -->
                                            <!-- <el-button v-if="scope.row.p_username != 0 && admin_token == 'admin'" type="danger" icon="el-icon-delete" size="mini" @click="DelUser(scope.row.username)"></el-button> -->
                                            <el-tooltip class="item" effect="dark" content="积分详情" placement="top">
                                                <el-button type="success" icon="el-icon-coin" size="mini" @click="JiFen(scope1.row.username)"></el-button>
                                            </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        
                    </template>
                </el-table-column>           
                <el-table-column label="ID" type="index"  width="100" ></el-table-column>
                <el-table-column label="用户名" prop="username" width="150"></el-table-column>
                <el-table-column label="昵称" prop="nick_name" width="150"></el-table-column>
                <el-table-column label="积分" prop="integral" width="150"></el-table-column>
                <el-table-column label="提成" prop="ticheng" width="150">
                    <template  slot-scope="scope">
                        ￥{{ scope.row.ticheng }}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" prop="name" width="150"></el-table-column>
                <el-table-column label="身份证" prop="sfz" width="200"></el-table-column>
                <el-table-column label="经销商" prop="is_dealer" width="100">
                    <template  slot-scope="scope">
                        <span style="color:#33cc00" v-if="scope.row.is_dealer">是</span>
                        <span style="color:#ff0000" v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column label="锁定" prop="is_activated" width="120">
                    <template  slot-scope="scope">
                        <i class="el-icon-lock" v-if="scope.row.is_deleted == 1" style="font-size: 14px;"></i>
                        <span style="color:#33cc00" v-else>正常</span>
                    </template>
                </el-table-column>
                <el-table-column label="注册时间" prop="reg_time" width="200"></el-table-column>
                <el-table-column label="操作">
                    <!--作用域插槽-->
                    <template slot-scope="scope"> 
                            <el-button type="primary" icon="el-icon-edit" size="mini" @click="EditUser(scope.row.username)" v-if="admin_token == 'admin' || admin_token == 'user'"></el-button>
                            <!-- <el-button v-if="scope.row.p_username != 0 && admin_token == 'admin'" type="danger" icon="el-icon-delete" size="mini" @click="DelUser(scope.row.username)"></el-button> -->
                            <el-tooltip class="item" effect="dark" content="积分详情" placement="top">
                                <el-button type="success" icon="el-icon-coin" size="mini" @click="JiFen(scope.row.username)"></el-button>
                            </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加用户对话框-->
            <el-dialog title="添加用户" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="addForm.username"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="addForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证" prop="sfz">
                        <el-input v-model="addForm.sfz"></el-input>
                    </el-form-item>
                    <el-form-item label="昵称" prop="nickname">
                        <el-input v-model="addForm.nickname"></el-input>
                    </el-form-item>
                    <el-form-item label="积分" prop="integral">
                        <el-input v-model="addForm.integral"></el-input>
                    </el-form-item>
                    <el-form-item label="是否是经销商" prop="is_dealer">
                            <el-switch v-model="addForm.is_dealer" :active-value="1" :inactive-value="0"> </el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addUser">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加用户对话框-->
            <!--编辑用户对话框-->
            <el-dialog title="编辑用户" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
                <!-- {{editForm}} -->
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="editForm.username" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="editForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证" prop="sfz">
                        <el-input v-model="editForm.sfz"></el-input>
                    </el-form-item>
                    <el-form-item label="昵称" prop="nick_name">
                        <el-input v-model="editForm.nick_name"></el-input>
                    </el-form-item>
                    <span   v-if="admin_token == 'admin'">
                        <el-form-item label="积分" prop="integral">
                            <el-input v-model="editForm.integral"></el-input>
                        </el-form-item>
                        <el-form-item label="是否经销商" prop="is_dealer">
                            <el-switch v-model="editForm.is_dealer" :active-value="1" :inactive-value="0"> </el-switch>
                        </el-form-item>
                        <el-form-item label="是否锁定" prop="is_deleted">
                            <el-switch v-model="editForm.is_deleted" :active-value="1" :inactive-value="0"> </el-switch>
                        </el-form-item>
                    </span>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="EditUserSave">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑用户对话框-->
            <!--积分详情对话框-->
            <el-dialog title="积分详情" :visible.sync="jfDialogVisible" width="60%"  @close="jfDialogClosed">
                <el-card>
                    <el-table :data="integrallist"  :key="integrallist.id" style="width: 100%" stripe size="small" height="400">
                        <el-table-column label="ID" type="index"></el-table-column>
                        <el-table-column label="用户" prop="username"></el-table-column>
                        <el-table-column label="描述" prop="info">
                            <template slot-scope="scope">
                                {{scope.row.info}}<span style="color:#ccc"> {{scope.row.from_username}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态">
                                <template slot-scope="scope">
                                <span :style="scope.row.sign=='+'?'color:#ff0000':'color:green'">{{scope.row.sign}} {{scope.row.integral}}</span>
                                </template>
                        </el-table-column>
                        <el-table-column label="操作时间" prop="adddate"></el-table-column>
                    </el-table>
                </el-card>
            </el-dialog>
            <!--积分详情对话框-->
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        //验证手机的规则
		var checkMobile = (rule,value,cb) => {
			const regMobile = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/
			if(regMobile.test(value)){
				return cb()
			}
			cb(new Error('请输入合法的手机号！'))
		}
        return{
            imgURL:this.GLOBAL.imgURL,
            addDialogVisible:false,
            editDialogVisible:false,
            showDialogVisible:false,
            jfDialogVisible:false,
            update: false,
            detaillist:[],
            //获取用户列表的参数对象
            queryInfo: {
                query: '',
                lock_user:false,
                pagenum: 1,
                pagesize: 10
            },
            userlist: [],
            integrallist:[],
            username:'',
            total: 0,
            //添加表单数据
            addForm:{
                 username:'',
                 nickname:'',
                 name:'',
                 sfz:'',
                 integral:0,
                 is_dealer:0
            },
            //添加表单验证规则
            addFormRules:{
                username:[
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { validator: checkMobile, trigger: 'blur'}
                ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
                ]
            },
            //编辑表单数据
            editForm:{
                 name:'',
                 sfz:'',
                 integral:0,
                 is_dealer:0,
                 is_deleted:0
            },
            //编辑表单验证规则
            editFormRules:{

            },
        }
        
    },
    created() {
         this.admin_token = window.sessionStorage.getItem('admin_token')
         this.getUserList()
    },
    mounted(){
    },
    methods:{
        async getUserList() {
           const { data: res} = await this.$http.get('dealerlist/',{ params: this.queryInfo })
           if(res.status == 1){
                this.total = res.data.totalCount;
                this.userlist = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
            }
            for (let index = 0; index < res.data.list.length; index++) {
                this.userlist[index].id= res.data.list[index].pk;
            }
            console.log(this.userlist)
        },

       handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getUserList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getUserList()
       },
       addDialogClosed(){
            this.$refs.addFormRef.resetFields()
       },
       async addUser(){
              this.$refs.addFormRef.validate( async valid=>{
                if (!valid) return
                const { data:res } = await this.$http.post('useradd/',this.addForm)
                if(res.status===0)
                {
                    this.$message.success('添加用户成功！')
                    this.addDialogVisible = false
                    this.getUserList()
                }
              })
       },
       async EditUser(username){
           const { data: res } = await this.$http.post('user_info/',{username:username})
            this.editForm = res
            this.editDialogVisible = true
       },
       EditUserSave(){
           this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                const { data: res } = await this.$http.post('useredit/' + this.editForm.username,this.editForm)
                if (res.status === 0) {
                    this.$message.success('用户修改成功')
                    this.editDialogVisible = false
                    this.getUserList()
                }
            })
       },
       editDialogClosed(){
            this.$refs.editFormRef.resetFields()
       },
       jfDialogClosed(){
            this.activeName = 'first'
       },
       async DelUser(username){
                const confirmResult = await this.$confirm('是否要删除此用户吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).catch(err => err)

                    if (confirmResult !== 'confirm'){
                        return this.$message.info('已取消删除！')
                    }
                    const { data: res } = await this.$http.get('userdel/'+ username)
                
                    if (res.status === 0) { 
                        this.$message({message: '删除成功！',type: 'success'})
                    }
                    else{
                         this.$message({message: '该用户购买过主要商品，不能删除！',type: 'warning'})
                    }
                    this.getUserList()
       },
      async ShowImg(username){
           this.showDialogVisible = true
      },
      async JiFen(username){
            this.jfDialogVisible = true
            const { data: res} = await this.$http.get('points/',{ params:{ username:username }})
            if(res.status === 0)
            {
                this.integrallist = res.data
            }
    
      }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;
    
    }
</style>